import type { PropsWithChildren } from 'react'

import styles from './RadialDial.module.css'

export const RadialDial = ({ children }: PropsWithChildren) => (
  <div className={styles.container}>{children}</div>
)

export const UpTo40PercentLessEdits = () => (
  <div className={styles.upToContainer}>
    <div className={styles.variant1__containerInner}>
      <div className={styles.upTo}>up to</div>
      <div className={styles.bigText}>40</div>
      <div className={styles.lessEdits}>less edits</div>
    </div>
    <div className={styles.percentage}>%</div>
  </div>
)

export const DialVariant1 = () => (
  <RadialDial>
    <div className={styles.variant1__container}>
      <UpTo40PercentLessEdits />
    </div>
  </RadialDial>
)

export const DialVariant2 = () => (
  <RadialDial>
    <div className={styles.variant2__container}>
      <div className={styles.variant2__innerContainer}>
        <div className={styles.variant2__left}>
          <div className={styles.variant2__number}>2</div>
        </div>
        <div className={styles.variant2__right}>
          <div className={styles.variant2__text}>
            Up to <br />
            edit-free <br />
            translations
          </div>
          <div className={styles.variant2__decimal}>.5X</div>
        </div>
      </div>
    </div>
  </RadialDial>
)
